export enum UserStatuses {
  SIGNUP = 'signup',
  TRIAL = 'trial',
  SUBSCRIBER = 'subscriber',
  CANCELLED = 'cancelled',
  ONDEMAND = 'ondemand',
  PENDING_CANCELLATION = 'pending_cancellation',
  WIX_USER = 'wix-user'
}
